module.exports = __webpack_public_path__ + "images/CrowdStrike-b04e1d.png";